import { eventBus } from '@shared/utils/event-bus/event-bus.util';

// Backwards-compatible small API so existing code can register a local listener
import type { BaseEvent, EventSubscription } from '@app-types/events';

export type ToastType = 'info' | 'success' | 'warning' | 'error';

export interface ToastMessage {
  id: string;
  title: string;
  message?: string;
  type?: ToastType;
  ttl?: number; // ms
  position?: 'center' | 'bottom-right';
}

// Event shape for event-bus (extends BaseEvent)
export interface ToastEvent extends BaseEvent {
  type: 'toast:show';
  id: string;
  title: string;
  message?: string;
  toastType?: ToastType;
  ttl?: number;
  position?: 'center' | 'bottom-right';
}

let subscription: EventSubscription | null = null;

export const registerToastEmitter = (fn: (t: ToastMessage) => void): EventSubscription => {
  // Use a typed listener on the central event bus
  subscription = eventBus.on<ToastEvent>('toast:show', (e) => {
    fn({
      id: e.id,
      title: e.title,
      message: e.message,
      type: e.toastType as ToastType,
      ttl: e.ttl,
      position: e.position,
    });
  });
  return subscription;
};

export const deregisterToastEmitter = () => {
  subscription?.unsubscribe();
  subscription = null;
};

export const emitToast = (t: ToastMessage) =>
  eventBus.emit<ToastEvent>('toast:show', {
    id: t.id,
    title: t.title,
    message: t.message,
    toastType: t.type,
    ttl: t.ttl,
    position: t.position,
  });

export default { registerToastEmitter, deregisterToastEmitter, emitToast };
